import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { gameUrl } from "../lib/api";
import { toggleFav, useList, FAV } from "../lib/store";
import { track, gameParams } from "../lib/analytics";

export function useHoverVideo(video) {
  const [show, setShow] = useState(false);
  const t = useRef(null);
  const canHover = typeof window !== "undefined" && window.matchMedia("(hover: hover)").matches;
  const on = () => {
    if (!video || !canHover) return;
    t.current = setTimeout(() => setShow(true), 250);
  };
  const off = () => {
    clearTimeout(t.current);
    setShow(false);
  };
  return { show, on, off };
}

export function HoverVideo({ src }) {
  return (
    <div className="game-item-video">
      <video src={src} autoPlay muted loop playsInline />
    </div>
  );
}

export function GameItem({ g, slider = false, badge }) {
  const favs = useList(FAV);
  const isFav = favs.includes(g.slug);
  const { show, on, off } = useHoverVideo(g.video);
  const Tag = slider ? "li" : "div";
  return (
    <Tag className={slider ? "post splide__slide item_game slider_item" : "post"} data-testid={`game-card-${g.slug}`}>
      <Link to={gameUrl(g.slug)} className="game-item" aria-label={g.title} onMouseEnter={on} onMouseLeave={off}>
        <img src={g.image} alt={g.title} loading="lazy" width="169" height="125" />
        {show && <HoverVideo src={g.video} />}
        <p className="post-name" style={{ zIndex: 3 }}>{g.title}</p>
        {badge && <span className="gg-badge">{badge}</span>}
        <button
          type="button"
          className={`gg-fav ${isFav ? "on" : ""}`}
          aria-label={isFav ? "Rimuovi dai preferiti" : "Aggiungi ai preferiti"}
          data-testid={`fav-toggle-${g.slug}`}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (!isFav) track("add_to_favorites", gameParams(g));
            toggleFav(g.slug);
          }}
        >
          <i className={isFav ? "fa-solid fa-heart" : "fa-regular fa-heart"} />
        </button>
      </Link>
    </Tag>
  );
}
